var _module_exports = "<fancy-group-by get-suggestions=\"getSuggestions\" group-by=\"groupBy\" group-by-limit=\"{{heatmap.mode().alwaysGroupBy ? 1 : 2}}\"></fancy-group-by>\n";;
var path = '/builds/observability/imm/signalview/src/legacy/app/heatmap/heatmapGroupBy.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;